import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CustomHttpService } from 'src/app/private/services/custom-http.service';
import { AppCookieService } from 'src/app/utils/AppCookieService';
import { LocalStorageService } from 'src/app/utils/LocalStorageService';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  constructor(private http: CustomHttpService, private localStorage: LocalStorageService, private cookies: AppCookieService) { }

  loginUser(data: any): Observable<any> {
    return this.http.post(environment.loginUser, data);
  }
  forgetPassword(data: any): Observable<any> {
    return this.http.post(environment.forgotPassword, data);
  }
  resetPassword(data: any): Observable<any> {
    return this.http.post(environment.resetPassword, data);
  }

  verifyOtp(data: any): Observable<any> {
    return this.http.post(environment.verifyOtp, data);
  }

  logOut() {

    const botScript = document.getElementById('gr-ai-bot');
    if (botScript) {
      console.log("Bot script removed")
        botScript.remove();
        window.location.reload();
    }

    this.cookies.remove("token")
    this.localStorage.logout();
  }

}
